import { useMemo, useState } from 'react';
import { DataTable } from '../../components/ui/DataTable';
import { Pagination } from '../../components/ui/Pagination';

const MOCK_BATCHES = Array.from({ length: 147 }, (_, index) => ({
  id: `batch-${index + 1}`,
  sr: index + 1,
  batchId: `B-${1000 + index}`,
  risk: index % 3 === 0 ? 'High' : index % 2 === 0 ? 'Medium' : 'Low',
  file: `loan_batch_${String(index + 1).padStart(3, '0')}.zip`,
  received: '2026-03-01',
  folders: 10 + (index % 40),
  queue: index % 4 === 0 ? 'PayZen' : 'Standard',
  status: index % 5 === 0 ? 'In review' : 'Received',
}));

/**
 * Local-only sample table + ABDP-style pagination (no API).
 * Open http://localhost:3000/dev/pagination-preview while `npm start` is running.
 */
export function PaginationPreviewPage() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const total = MOCK_BATCHES.length;
  const rows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return MOCK_BATCHES.slice(start, start + pageSize);
  }, [page, pageSize]);

  const columns = [
    { key: 'sr', header: 'Sr. No' },
    { key: 'batchId', header: 'Batch ID' },
    { key: 'risk', header: 'Risk Level' },
    { key: 'file', header: 'Contract File' },
    { key: 'received', header: 'Received At' },
    { key: 'folders', header: 'No. of Folders' },
    { key: 'queue', header: 'Queue' },
    { key: 'status', header: 'Status' },
  ];

  if (process.env.NODE_ENV === 'production') {
    return (
      <main className="mx-auto max-w-lg p-8 text-sm text-eorig-muted">
        Pagination preview is disabled in production builds.
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-[#F4F6F8] p-6 md:p-10">
      <div className="mx-auto max-w-6xl space-y-4">
        <header className="rounded-2xl border border-[#D8D4D4] bg-white p-4 md:p-5">
          <h1 className="text-lg font-semibold text-[#1F2933]">Pagination preview</h1>
          <p className="mt-1 text-sm text-[#5A5A5A]">
            Sample batch table with the shared ABDP-style pager (chevrons, page numbers, Table
            List, of N). Change page size to see totals update — same control used on Packages,
            Provider intake, Validation, and other list pages.
          </p>
        </header>

        <DataTable
          columns={columns}
          rows={rows}
          rowKey={(row) => row.id}
          loading={false}
          emptyMessage="No batches."
          minWidth={960}
        />

        <Pagination
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
          onPageSizeChange={(size) => {
            setPage(1);
            setPageSize(size);
          }}
        />
      </div>
    </main>
  );
}
